import React, { Component } from "react";
import { Modal, Card } from "react-bootstrap";
import "../styling/Styles.css";
import "./bl.scss";
import { FormGroup, Col, Row } from "reactstrap";
import { connect } from "react-redux";
import Button from "@material-ui/core/Button";

import { SelectArticle } from "../../redux/actions/GetArticles";
import { TextField, Fab, IconButton, FormHelperText } from "@material-ui/core";
import "../styling/Styling.scss";
import Center from "react-center";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import DeleteIcon from "@material-ui/icons/Delete";
import Tooltip from "@material-ui/core/Tooltip";
import EditIcon from "@material-ui/icons/Edit";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Switch from "@material-ui/core/Switch";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import EditRowModal from "./EditRowModal";
import { SelectBL } from "../../redux/actions/GetBL";
import { Redirect } from "react-router-dom";
import { SelectClient } from "../../redux/actions/GetClients";
import translate from "../../i18n/translate";
import { withStyles } from "@material-ui/styles";
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";

const stylesFn = () => ({
  input: {
    color: "#fff",
  },
  root: {
    "& label.Mui-focused": {
      color: "#fff",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#fff",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#fff",
      },
      "&.Mui-disabled fieldset": {
        borderColor: "#fff",
      },
      "&:hover fieldset": {
        borderColor: "#fff",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#fff",
      },
    },
  },
});

class ModifierBLModal extends Component {
  constructor(props) {
    super(props);
    const username = localStorage.getItem("username");

    this.state = {
      codearticle: "",
      qte: "",
      totalht: 0,
      des: "",
      unite: "",
      puht: "",
      remisea: 0,
      tva: 0,
      puttcnet: 0,
      faudec: "",
     
      tab: [],
      totalqte: 0,
      sumremisearticle: 0,
      totalhtbrut: 0,
      totaltva: 0,
      totalFodec:0,
      totalhtnet: 0,
      remiseglobal: 0,
      netapayer: 0,
      snackbaropen: false,
      snackbarfail: false,
      editModalShow: false,
      qtte: 0,
      btnEnabled: false,
      gilad: true,
      snackbarmsg: "",
      enrsnackbaropen: false,
      fsnackbaropen: false,
      pmp: "",

      openEditModal: false,
      idel: 0,
      reload: false,

      giladd: true,

      rechs: [],
      rechsc: [],

      changeButton: false,

      remiseg: 0,
      raisonsocial: "",
      codeclient: "",
      categoriefiscale: "",
      showFodec:false,
      datebcc: "",

      username: username,
      clicked: false,
      clickeda: false,

      stkfin: 0,
      yesno: "",
    };
  }

  componentDidMount() {
    this.props.SelectArticle(
      this.props.ConfigDossier.coddos,
      this.props.ConfigDossier.serveur,
      this.props.ConfigDossier.utilisateur,
      this.props.ConfigDossier.pwd_serveur,
      this.props.ConfigDossier.database
    );
    this.sameTable();
    this.props.SelectClient(
      this.props.ConfigDossier.coddos,
      this.props.ConfigDossier.serveur,
      this.props.ConfigDossier.utilisateur,
      this.props.ConfigDossier.pwd_serveur,
      this.props.ConfigDossier.database
    );
 
    this.setState({
      remiseg: this.props.taurem,
      raisonsocial: this.props.raisonsociale,
      showFodec:this.props.fodec,
      codeclient: this.props.client,
      categoriefiscale: this.props.catfisc,
      datebcc: new Date(this.props.datebl)
        .toLocaleDateString()
        .substring(0, 10)
        .split("/")
        .reverse()
        .join("-"),
    });
  }

  datHandler = (event) => {
    this.setState({ datebcc: event.target.value });
  };

  raisocHandler = (event) => {
    this.setState({ raisonsocial: event.target.value });
  };

  remiseglobalChange = (event) => {
    this.setState({ remiseg: event.target.value });
  };

  remiseHandler = (event) => {
    this.setState({
      remisea: event.target.value,
      totalht: Number(
        this.state.qte * this.state.puht * ((100 - event.target.value) / 100)
      ).toFixed(3),
      puttcnet: (
        this.state.puht *
        (1 + this.state.tva / 100) *
        ((100 - event.target.value) / 100)
      ).toFixed(3),
    });
  };

  puhtHandler = (event) => {
    this.setState({
      puht: event.target.value,
      totalht:
        this.state.qte *
        event.target.value *
        ((100 - this.state.remisea) / 100),
      puttcnet: Number(
        event.target.value *
          (1 + this.state.tva / 100) *
          ((100 - this.state.remisea) / 100)
      ).toFixed(3),
    });
  };

  puttcHandler = (event) => {
    this.setState({
      puttcnet: Number(event.target.value).toFixed(3),
      puht: (
        event.target.value /
        ((100 - this.state.remisea) / 100) /
        (1 + this.state.tva / 100)
      ).toFixed(3),
      totalht: (
        this.state.qte *
        ((event.target.value /
          ((100 - this.state.remisea) / 100) /
          (1 + this.state.tva / 100)) *
          ((100 - this.state.remisea) / 100))
      ).toFixed(3),
    });
  };

  articleHandlerChange = (event) => {
    //get article tel que codart='codart'
    fetch(
      `https://www.24-crm.tn/webservice/api/ARTICLEs?codartt=${event.target.value}&coddos=${this.props.ConfigDossier.coddos}&serveur=${this.props.ConfigDossier.serveur}&user=${this.props.ConfigDossier.utilisateur}&pwd=${this.props.ConfigDossier.pwd_serveur}&database=${this.props.ConfigDossier.database}`
    )
      .then((response) => response.json())
      .then((data) => this.setState({ rechs: data, clickeda: true }));
  };

  clientHandlerChange = (event) => {
    //Recherche client par code client ou par raison social ou par num tel
    fetch(
      `https://www.24-crm.tn/webservice/api/CLIENTs?codclii=${event.target.value}&coddos=${this.props.ConfigDossier.coddos}&serveur=${this.props.ConfigDossier.serveur}&user=${this.props.ConfigDossier.utilisateur}&pwd=${this.props.ConfigDossier.pwd_serveur}&database=${this.props.ConfigDossier.database}`
    )
      .then((response) => response.json())
      .then((data) => this.setState({ rechsc: data, clicked: true }));
  };

  sameTable = () => {
    //sélectionner de la table V_CalcLIGBLBR
    fetch(
      `https://www.24-crm.tn/webservice/Api/LigBLBRs?type=BL&numfac=${this.props.blid}&coddos=${this.props.ConfigDossier.coddos}&serveur=${this.props.ConfigDossier.serveur}&user=${this.props.ConfigDossier.utilisateur}&pwd=${this.props.ConfigDossier.pwd_serveur}&database=${this.props.ConfigDossier.database}`
    )
      .then((response) => response.json())
      .then((data) =>
        this.setState({
          tab: data,
          //    sumqt: data && data.reduce((a, v) => a + parseInt(v.quantite), 0),
        })
      );
  };

  snackbarClose = (event) => {
    this.setState({ snackbaropen: false });
  };

  snackbarFailClose = (event) => {
    this.setState({ snackbarfail: false });
  };

  enrsnackbarClose = (event) => {
    this.setState({ enrsnackbaropen: false });
  };

  fsnackbarClose = (event) => {
    this.setState({ fsnackbaropen: false });
  };

  /////// modiifier les modifications /////////////
  modifiermodification = (event) => {
    // event.preventDefault();
    if (
      this.state.tab.filter((el) => el.codart == this.state.codearticle)
        .length > 0
    ) {
      alert("article existant");
      // const newtab = this.state.tab.map(el=>el.codart==this.state.codearticle?{...,}:el
      //  );
    } else {
      const newtab = this.state.tab.concat({
        codart: this.state.codearticle,
        desart: this.state.des,
        quantite: this.state.qte,
        unite: this.state.unite,
        priuni: this.state.puht,
        remise: this.state.remisea,
        tautva: this.state.tva,
        faudec: this.props.tabb?.[0]?.fodart,
        montht: this.state.totalht,
        PUTTCNET: this.state.puttcnet,
        pmp: this.state.pmp,
      });

      // const SumQte =
      //   newtab && newtab.reduce((a, v) => a + parseInt(v.quantite), 0);
      // const SumRemiseArticle =
      //   newtab &&
      //   newtab.reduce(
      //     (a, v) => a + (parseInt(v.quantite) * v.montht * v.remise) / 100,
      //     0
      //   );
      // const SumHtBrut =
      //   newtab &&
      //   newtab.reduce((a, v) => a + parseInt(v.quantite) * v.montht, 0);
      // const SumTva =
      //   newtab &&
      //   newtab.reduce(
      //     (a, v) =>
      //       a +
      //       parseInt(v.quantite) *
      //         v.montht *
      //         ((100 - v.remise) / 100) *
      //         (v.tautva / 100),
      //     0
      //   );
      // const SumHtNet =
      //   newtab &&
      //   newtab.reduce(
      //     (a, v) => a + v.montht * ((100 - this.props.rem) / 100),
      //     0
      //   );
      // const SumRemiseGlobale =
      //   newtab &&
      //   newtab.reduce((a, v) => a + v.montht * (this.props.rem / 100), 0);
      // const SumNetAPayer =
      //   newtab &&
      //   newtab.reduce(
      //     (a, v) =>
      //       a +
      //       (v.montht * ((100 - this.props.rem) / 100) +
      //         v.quantite *
      //           v.priuni *
      //           ((100 - v.remise) / 100) *
      //           (v.tautva / 100)),
      //     0
      //   );

      const SumQte = newtab && newtab.reduce((a, v) => a + parseInt(v.qte), 0);
      const SumRemiseArticle =
        newtab &&
        newtab.reduce(
          (a, v) => a + (parseInt(v.qte) * v.puht * v.remisea) / 100,
          0
        );
      const SumHtBrut =
        newtab && newtab.reduce((a, v) => a + parseInt(v.qte) * v.puht, 0);
     
       const SumHtNet =
        newtab &&
        newtab.reduce(
          (a, v) => a + v.totalht * ((100 - this.props.rem) / 100),
          0
        );
      const SumFodec =
      SumHtNet*
      Number(this.props.InfoEntreprise?.[0]?.taufodec ?? 0) /
      100;
      const taufodec = Number(this.props.InfoEntreprise?.[0]?.taufodec ?? 0);
const applyFodec = this.props.showFodec && this.state.faudec;

const SumTva =
  newtab &&
  newtab.reduce((a, v) => {
    const base =
      parseInt(v.qte) *
      v.puht *
      ((100 - v.remisea) / 100) *
      ((100 - this.props.rem) / 100);

    // Add FODEC before TVA if both booleans are true
    const baseWithFodec = applyFodec
      ? base * (1 + taufodec / 100)
      : base;

    const tvaAmount = baseWithFodec * (v.tva / 100);

    return a + tvaAmount;
  }, 0);

     
      const SumRemiseGlobale =
        newtab &&
        newtab.reduce((a, v) => a + v.totalht * (this.props.rem / 100), 0);
    
      const SumNetAPayer =SumHtNet+SumFodec+SumTva;
      const Avance = (SumNetAPayer * this.props.regimecli) / 100;
      const SumNetNetAPayer =
        Number(SumNetAPayer)  + Avance;
      this.setState({
        tab: newtab,

        totalqte: SumQte,
        sumremisearticle: SumRemiseArticle,
        totalhtbrut: SumHtBrut,
        totaltva: SumTva,
        totalFodec:SumFodec,
        totalhtnet: SumHtNet,
        remiseglobal: SumRemiseGlobale,
        netapayer: SumNetAPayer,
        snackbaropen: true,
        btnEnabled: true,
        changeButton: false,
      });

      this.setState({
        codearticle: "",
        qte: "",
        totalht: 0,
        des: "",
        unite: "",
        puht: "",
        remisea: 0,
        tva: 0,
        puttcnet: 0,
        faudec: "",
       
        stkfin: 0,
        pmp: "",
      });
    }
  };

  /////// submit pour le bouton ajouter /////////////

  submitHandler = (event) => {
    event.preventDefault();
    if (
      this.state.tab.filter((el) => el.codart == this.state.codearticle)
        .length > 0
    ) {
      alert("article existant, veuillez modifier la quantité ");
    } else {
      const newtab = this.state.tab.concat({
        codart: this.state.codearticle,
        desart: this.state.des,
        quantite: this.state.qte,
        unite: this.state.unite,
       faudec: this.props.tabb?.[0]?.fodart,
        priuni: this.state.puht,
        remise: event.target.remisea.value,
        tautva: this.state.tva,
        montht: this.state.totalht,
        PUTTCNET: this.state.puttcnet,
        pmp: this.state.pmp,
      });
    
      const SumQte = newtab && newtab.reduce((a, v) => a + parseInt(v.qte), 0);
      const SumRemiseArticle =
        newtab &&
        newtab.reduce(
          (a, v) => a + (parseInt(v.qte) * v.puht * v.remisea) / 100,
          0
        );
      const SumHtBrut =
        newtab && newtab.reduce((a, v) => a + parseInt(v.qte) * v.puht, 0);
    
       const SumHtNet =
        newtab &&
        newtab.reduce(
          (a, v) => a + v.totalht * ((100 - this.props.rem) / 100),
          0
        );
      const SumFodec =
      SumHtNet*
      Number(this.props.InfoEntreprise?.[0]?.taufodec ?? 0) /
      100;
      const taufodec = Number(this.props.InfoEntreprise?.[0]?.taufodec ?? 0);
const applyFodec = this.props.showFodec && this.state.faudec;

const SumTva =
  newtab &&
  newtab.reduce((a, v) => {
    const base =
      parseInt(v.qte) *
      v.puht *
      ((100 - v.remisea) / 100) *
      ((100 - this.props.rem) / 100);

    // Add FODEC before TVA if both booleans are true
    const baseWithFodec = applyFodec
      ? base * (1 + taufodec / 100)
      : base;

    const tvaAmount = baseWithFodec * (v.tva / 100);

    return a + tvaAmount;
  }, 0);

     
      const SumRemiseGlobale =
        newtab &&
        newtab.reduce((a, v) => a + v.totalht * (this.props.rem / 100), 0);
     
      const SumNetAPayer =SumHtNet+SumFodec+SumTva;
      const Avance = (SumNetAPayer * this.props.regimecli) / 100;
      const SumNetNetAPayer =
        Number(SumNetAPayer)  + Avance;
       
      this.setState({
        tab: newtab,

        totalqte: SumQte,
        sumremisearticle: SumRemiseArticle,
        totalhtbrut: SumHtBrut,
        totaltva: SumTva,
        totalFodec:SumFodec,
        totalhtnet: SumHtNet,
        remiseglobal: SumRemiseGlobale,
        netapayer: SumNetAPayer,
        snackbaropen: true,
        btnEnabled: true,
      });

      this.setState({
        codearticle: "",
        qte: "",
        totalht: 0,
        des: "",
        unite: "",
        puht: "",
        remisea: 0,
        tva: 0,
        puttcnet: 0,
        faudec: "",
        pmp: "",
        stkfin: 0,
      });
    }
  };

  onCellChange = (event) => {
    this.setState({ codearticle: event.target.value });
  };

  handleChange = (name) => (event) => {
    this.setState({ [name]: event.target.checked });
  };

  deleteRow = (index) => {
    var tab = [...this.state.tab];

    tab.splice(index, 1);
    // const SumQte = tab && tab.reduce((a, v) => a + parseInt(v.quantite), 0);
    // const SumRemiseArticle =
    //   tab &&
    //   tab.reduce(
    //     (a, v) => a + (parseInt(v.quantite) * v.priuni * v.remise) / 100,
    //     0
    //   );
    // const SumHtBrut =
    //   tab && tab.reduce((a, v) => a + parseInt(v.quantite) * v.priuni, 0);
    // const SumTva =
    //   tab &&
    //   tab.reduce(
    //     (a, v) =>
    //       a +
    //       parseInt(v.quantite) *
    //         v.priuni *
    //         ((100 - v.remise) / 100) *
    //         (v.tautva / 100),
    //     0
    //   );
    // const SumHtNet =
    //   tab &&
    //   tab.reduce((a, v) => a + v.montht * ((100 - this.props.rem) / 100), 0);
    // const SumRemiseGlobale =
    //   tab && tab.reduce((a, v) => a + v.montht * (this.props.rem / 100), 0);
    // const SumNetAPayer =
    //   tab &&
    //   tab.reduce(
    //     (a, v) =>
    //       a +
    //       (v.montht * ((100 - this.props.rem) / 100) +
    //         parseInt(v.quantite) *
    //           v.priuni *
    //           ((100 - v.remise) / 100) *
    //           (v.tautva / 100)),
    //     0
    //   );

    // this.setState({
    //   tab,
    //   totalqte: SumQte,
    //   sumremisearticle: SumRemiseArticle,
    //   totalhtbrut: SumHtBrut,
    //   totaltva: SumTva,
    const SumQte = tab && tab.reduce((a, v) => a + parseInt(v.qte), 0);
    const SumRemiseArticle =
      tab &&
      tab.reduce((a, v) => a + (parseInt(v.qte) * v.puht * v.remisea) / 100, 0);
    const SumHtBrut =
      tab && tab.reduce((a, v) => a + parseInt(v.qte) * v.puht, 0);
    const SumTva =
      tab &&
      tab.reduce(
        (a, v) =>
          a +
          parseInt(v.qte) *
            v.puht *
            ((100 - v.remisea) / 100) *
            ((100 - this.props.rem) / 100) *
            (v.tva / 100),
        0
      );
    const SumHtNet =
      tab &&
      tab.reduce((a, v) => a + v.totalht * ((100 - this.props.rem) / 100), 0);
    const SumRemiseGlobale =
      tab && tab.reduce((a, v) => a + v.totalht * (this.props.rem / 100), 0);
    const SumNetAPayer =
      tab &&
      tab.reduce(
        (a, v) =>
          a +
          (v.totalht * ((100 - this.props.rem) / 100) +
            parseInt(v.qte) *
              v.puht *
              ((100 - v.remisea) / 100) ** ((100 - this.props.rem) / 100) *
              (v.tva / 100)),
        0
      );


    const Avance = (SumNetAPayer * this.props.regimecli) / 100;

    const SumNetNetAPayer = SumNetAPayer + Avance;
    const SumFodec =
    Number(this.state.totalhtnet ?? 0) *
    Number(this.props.InfoEntreprise?.[0]?.taufodec ?? 0) /
    100;
    this.setState({
      tab,
      totalqte: SumQte,
      sumremisearticle: SumRemiseArticle,
      totalhtbrut: SumHtBrut,
      totaltva: SumTva,
      totalFodec:SumFodec,
      totalhtnet: SumHtNet,
      remiseglobal: SumRemiseGlobale,
      netapayer: SumNetAPayer,
      snackbarfail: true,
      btnEnabled: true,
    });
    // mise a jour stock après suppression
    // fetch(
    //   `/api/LigBLBRs?fac=${this.props.blid}&Typfacs=BL&NumComs=&Typcoms=&GMMs=&CODDEPs=&GNSs=`,
    //   {
    //     method: "POST",
    //     header: {
    //       Accept: "application/json",
    //       "Content-Type": "application/json",
    //     },
    //   }
    // )
    //   .then((res) => res.json())
    //   .then(
    //     (result) => {
    //       console.log("mise a jour stock avec succée");
    //       console.log(result);
    //     },
    //     (error) => {
    //       this.setState({ snackbaropen: true, snackbarmsg: "failed" });
    //     }
    //   );
  };

  ///////////// delete for modification without snackbaropende ///////////
  deleteRowMod = (index) => {
 
    var tab = [...this.state.tab];
  
    tab.splice(index, 1);
    // const SumQte = tab && tab.reduce((a, v) => a + parseInt(v.quantite), 0);
    // const SumRemiseArticle =
    //   tab &&
    //   tab.reduce(
    //     (a, v) => a + (parseInt(v.quantite) * v.priuni * v.remise) / 100,
    //     0
    //   );
    // const SumHtBrut =
    //   tab && tab.reduce((a, v) => a + parseInt(v.quantite) * v.priuni, 0);
    // const SumTva =
    //   tab &&
    //   tab.reduce(
    //     (a, v) =>
    //       a +
    //       parseInt(v.quantite) *
    //         v.priuni *
    //         ((100 - v.remise) / 100) *
    //         (v.tautva / 100),
    //     0
    //   );
    // const SumHtNet =
    //   tab &&
    //   tab.reduce((a, v) => a + v.montht * ((100 - this.props.rem) / 100), 0);
    // const SumRemiseGlobale =
    //   tab && tab.reduce((a, v) => a + v.montht * (this.props.rem / 100), 0);
    // const SumNetAPayer =
    //   tab &&
    //   tab.reduce(
    //     (a, v) =>
    //       a +
    //       (v.montht * ((100 - this.props.rem) / 100) +
    //         parseInt(v.quantite) *
    //           v.priuni *
    //           ((100 - v.remise) / 100) *
    //           (v.tautva / 100)),
    //     0
    //   );

    // this.setState({
    //   tab,
    //   totalqte: SumQte,
    //   sumremisearticle: SumRemiseArticle,
    //   totalhtbrut: SumHtBrut,
    //   totaltva: SumTva,
    const SumQte = tab && tab.reduce((a, v) => a + parseInt(v.qte), 0);
    const SumRemiseArticle =
      tab &&
      tab.reduce((a, v) => a + (parseInt(v.qte) * v.puht * v.remisea) / 100, 0);
    const SumHtBrut =
      tab && tab.reduce((a, v) => a + parseInt(v.qte) * v.puht, 0);
    // const SumTva =
    //   tab &&
    //   tab.reduce(
    //     (a, v) =>
    //       a +
    //       parseInt(v.qte) *
    //         v.puht *
    //         ((100 - v.remisea) / 100) *
    //         ((100 - this.props.rem) / 100) *
    //         (v.tva / 100),
    //     0
    //   );
    const SumHtNet =
        tab &&
        tab.reduce(
          (a, v) => a + v.totalht * ((100 - this.props.rem) / 100),
          0
        );
      const SumFodec =
      SumHtNet*
      Number(this.props.InfoEntreprise?.[0]?.taufodec ?? 0) /
      100;
    const taufodec = Number(this.props.InfoEntreprise?.[0]?.taufodec ?? 0);
    const applyFodec = this.props.showFodec && this.state.faudec;
    
    const SumTva =
    tab &&
    tab.reduce((a, v) => {
      const base =
        parseInt(v.qte) *
        v.puht *
        ((100 - v.remisea) / 100) *
        ((100 - this.props.rem) / 100);

      // Add FODEC before TVA if both booleans are true
      const baseWithFodec = applyFodec
        ? base * (1 + taufodec / 100)
        : base;

      const tvaAmount = baseWithFodec * (v.tva / 100);

      return a + tvaAmount;
    }, 0);
    
    const SumRemiseGlobale =
      tab && tab.reduce((a, v) => a + v.totalht * (this.props.rem / 100), 0);
    // const SumNetAPayer =
    //   tab &&
    //   tab.reduce(
    //     (a, v) =>
    //       a +
    //       (v.totalht * ((100 - this.props.rem) / 100) +
    //         parseInt(v.qte) *
    //           v.puht *
    //           ((100 - v.remisea) / 100) *
    //           (v.tva / 100)),
    //     0
    //   );
    const SumNetAPayer =SumHtNet+SumFodec+SumTva;

    const Avance = (SumNetAPayer * this.props.regimecli) / 100;
    const SumNetNetAPayer =
      Number(SumNetAPayer)  + Avance;
   
    this.setState({
      tab,
      totalqte: SumQte,
      sumremisearticle: SumRemiseArticle,
      totalhtbrut: SumHtBrut,
      totaltva: SumTva,
      totalFodec:SumFodec,
      totalhtnet: SumHtNet,
      remiseglobal: SumRemiseGlobale,
      netapayer: SumNetAPayer,
      btnEnabled: true,
    });
    //   },
    //   (error) => {
    //     this.setState({ snackbaropen: true, snackbarmsg: "failed" });
    //   }
    // );
  };

  qteHandler = (event) => {
    this.setState({
      qte: event.target.value,
      puttcnet: Number(this.state.puht * (1 + this.state.tva / 100)).toFixed(3),
      totalht: Number(
        event.target.value *
          this.state.puht *
          ((100 - this.state.remisea) / 100)
      ).toFixed(3),
    });

    this.state.stkfin >= parseInt(event.target.value)
      ? this.setState({ yesno: "yes" })
      : this.setState({ yesno: "no" });
  };

  enregistrer = () => {
    ///////////////// Update blbrs ////////////

    fetch(
      `https://www.24-crm.tn/webservice/api/BLBRs?numfac=${this.props.blid}&typfac=BL&datfac=${this.state.datebcc}&codcli=${this.state.codeclient}&raisoc=${this.state.raisonsocial}&taurem=${this.state.remiseg}&catfisc=${this.state.categoriefiscale}&timbre=${this.props.droitdetimbre}&fodcli=${this.props.fodeccli}&ForfaitCli=${this.props.avanceimpot}&VENDEUR=${this.props.Auth.username}&facture=${this.props.facture}&coddos=${this.props.ConfigDossier.coddos}&serveur=${this.props.ConfigDossier.serveur}&user=${this.props.ConfigDossier.utilisateur}&pwd=${this.props.ConfigDossier.pwd_serveur}&database=${this.props.ConfigDossier.database}`,

      {
        method: "PUT",
        header: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    )
    
      .then((result) => {
        ////////// first part delete ///////////////////
        fetch(
          `https://www.24-crm.tn/webservice/api/LigBLBRs/${this.props.blid}?typfacc=BL&coddos=${this.props.ConfigDossier.coddos}&serveur=${this.props.ConfigDossier.serveur}&user=${this.props.ConfigDossier.utilisateur}&pwd=${this.props.ConfigDossier.pwd_serveur}&database=${this.props.ConfigDossier.database}`,
          {
            method: "DELETE",
            header: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        )
          .then((res) => res.json())
          .then((result) => {
            ///////////// second part add new table to database //////////////

            this.state.tab.map(
              (k, index) => {
                // ajouter l'élément à la table ligblbr
                fetch(
                  `https://www.24-crm.tn/webservice/api/LigBLBRs/{ID}?numfac=${
                    this.props.blid
                  }&typfac=BL&numlig=${index + 10}&codart=${
                    k.codart
                  }&quantite=${k.quantite}&fodart=${k.faudec}&desart=${k.desart}&datfac=${
                    this.props.datebl
                  }&priuni=${k.priuni}&remise=${k.remise}&unite${
                    k.unite
                  }&codtva=3&pmp=${k.pmp}&tautva=${k.tautva}&coddos=${
                    this.props.ConfigDossier.coddos
                  }&serveur=${this.props.ConfigDossier.serveur}&user=${
                    this.props.ConfigDossier.utilisateur
                  }&pwd=${this.props.ConfigDossier.pwd_serveur}&database=${
                    this.props.ConfigDossier.database
                  }`,
                  {
                    method: "POST",
                    header: {
                      Accept: "application/json",
                      "Content-Type": "application/json",
                    },
                  }
                )
                  .then((res) => res.json())
                  .then(
                    (result) => {
                      //this.setState({ enrsnackbaropen: true, snackbarmsg: result });

                      //// third part calcul with sommeTTCbl/////////////
                      fetch(
                        `https://www.24-crm.tn/webservice/api/LigBLBRs?FAC=${this.props.blid}&typfacc=BL&coddos=${this.props.ConfigDossier.coddos}&serveur=${this.props.ConfigDossier.serveur}&user=${this.props.ConfigDossier.utilisateur}&pwd=${this.props.ConfigDossier.pwd_serveur}&database=${this.props.ConfigDossier.database}`,
                        {
                          method: "POST",
                          header: {
                            Accept: "application/json",
                            "Content-Type": "application/json",
                          },
                        }
                      )
                        .then((res) => res.json())
                        .then(
                          (result) => {
                            // this.setState({ snackbaropen: true, snackbarmsg: result });

                          //  window.location.reload();
                          },
                          (error) => {
                            this.setState({
                              snackbaropen: true,
                              snackbarmsg: "failed",
                            });
                          }
                        );
                    },
                    (error) => {
                      this.setState({
                        enrsnackbaropen: true,
                        snackbarmsg: "failed",
                      });
                    }
                  );
              },
              (error) => {
                this.setState({
                  enrsnackbaropen: true,
                  snackbarmsg: "failed",
                });
              }
            );
          })
          .then(
            (result) => {
              this.props.onHide();

              this.props.SelectBL(
                this.props.ConfigDossier.coddos,
                this.props.ConfigDossier.serveur,
                this.props.ConfigDossier.utilisateur,
                this.props.ConfigDossier.pwd_serveur,
                this.props.ConfigDossier.database
              );
              //Exécuter la procédure RecalculSoldeCliNew (recalculer le solde du client)
            },
            (error) => {
              this.setState({ snackbaropen: true, snackbarmsg: "failed" });
            }
          );
       
      })
      .then((res) => {
        fetch(
          `https://www.24-crm.tn/webservice/api/REGCLIs?codeclii=${this.state.codeclient}&coddos=${this.props.ConfigDossier.coddos}&serveur=${this.props.ConfigDossier.serveur}&user=${this.props.ConfigDossier.utilisateur}&pwd=${this.props.ConfigDossier.pwd_serveur}&database=${this.props.ConfigDossier.database}`,
          {
            method: "POST",
            header: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        );
      });
    // .then(() => {
    //   window.location.reload();
    // });
  };

  render() {
   console.log("fodecart",this.props.tabb[0]?.fodart)
    let editModalClose = () => this.setState({ editModalShow: false });

    let EditModalClose = () => this.setState({ openEditModal: false });


    const theme = createMuiTheme({
      overrides: {
        MuiSwitch: {
          switchBase: {
            color: "#BEBEBE",
            "&$checked": {
              color: "#BEBEBE",
            },
          },
          track: {
            opacity: 0.2,
            backgroundColor: "#BEBEBE",
            "$checked$checked + &": {
              opacity: 0.7,
              backgroundColor: "#BEBEBE",
            },
          },
        },
      },
    });

    const {
      quantt,
      remiss,
      artid,
      totalhtt,
      puttcnett,
      numligg,
      numfacccc,
      prixunix,
    } = this.state;

    if (this.state.reload) return <Redirect to="/bon-de-livraison" />;

    const { darck, classes } = this.props;

    return (
      <div className="container">
        <Snackbar
          open={this.state.snackbaropen}
          autoHideDuration={2000}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          onClose={this.snackbarClose}
        >
          <Alert
            style={{ height: "50px" }}
            onClose={this.snackbarClose}
            severity="success"
          >
            {translate("Article ajouté")}
          </Alert>
        </Snackbar>

        <Snackbar
          open={this.state.snackbarfail}
          autoHideDuration={2000}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          onClose={this.snackbarFailClose}
        >
          <Alert
            style={{ height: "50px" }}
            onClose={this.snackbarFailClose}
            severity="error"
          >
            {translate("Article supprimé")}
          </Alert>
        </Snackbar>

        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          open={this.state.enrsnackbaropen}
          autoHideDuration={2000}
          onClose={this.enrsnackbarClose}
          message={<span id="message-id"> {this.state.snackbarmsg} </span>}
          action={[
            <IconButton
              key="close"
              color="inherit"
              onClick={this.enrsnackbarClose}
            >
              x
            </IconButton>,
          ]}
        ></Snackbar>

        <Modal
          {...this.props}
          size="xl"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          backdrop="static"
          className={`${darck ? "" : classes.root}`}
        >
          <Modal.Header
            closeButton
            style={{
              backgroundColor: `${darck ? "#fff" : "#172431"}`,
              color: `${darck ? "#00087E" : "#fff"}`,
              borderTop: `${darck ? "" : "2px solid #fff"}`,
              borderRight: `${darck ? "" : "2px solid #fff"}`,
              borderLeft: `${darck ? "" : "2px solid #fff"}`,
              borderBottom: `none`,
            }}
          >
            <Modal.Title id="contained-modal-title-vcenter">
              <b>
                {" "}
                {translate("Modifier Bon de livraison №")} {this.props.blid}
              </b>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body
            style={{
              backgroundColor: `${darck ? "#fff" : "#172431"}`,
              borderTop: `none`,
              borderRight: `${darck ? "" : "2px solid #fff"}`,
              borderLeft: `${darck ? "" : "2px solid #fff"}`,
              borderBottom: `${darck ? "" : "2px solid #fff"}`,
            }}
          >
            <Row>
              <Col style={{ margin: "0" }}>
                <Card style={{ marginBottom: "10px" }}>
                  <Card.Body
                    style={{
                      backgroundColor: `${darck ? "#fff" : "#172431"}`,
                      border: `${darck ? "" : "2px solid #fff"}`,
                    }}
                  >
                    <Row style={{ marginBottom: "-20px", marginTop: "-20px" }}>
                      <Col sm={8}>
                        <FormGroup>
                          <Typography component="div">
                            <Grid
                              component="label"
                              container
                              alignItems="center"
                              spacing={1}
                            >
                              <Grid style={{ color: `${darck ? "" : "#fff"}` }}>
                                <b> {translate("Chercher client par")} :{this.props.fodeccli ? (
                          <><b>fodec: ✔ </b></>
                        ) : null}      </b>
                              </Grid>
                            
                 
                              &nbsp;&nbsp;
                              <Grid
                                item
                                style={{ color: `${darck ? "grey" : "#fff"}` }}
                              >
                                {translate("Raison social")}
                              </Grid>
                              <Grid item>
                                <ThemeProvider theme={theme}>
                                  <Switch
                                    checked={this.state.giladd}
                                    onChange={this.handleChange("giladd")}
                                    value="giladd"
                                    color="primary"
                                  />
                                </ThemeProvider>
                              </Grid>
                              <Grid item 
                                    style={{ color: `${darck ? "#3f51b5" : "#fff"}` }}>
                                <span style={{ color: !darck ? "#fff" : null }}>
                                  {translate("Code client")}
                                </span>
                              </Grid>
                            </Grid>
                          </Typography>
                        </FormGroup>
                      </Col>
                     
                      {this.state.giladd ? (
                        <Col sm={4} style={{  marginBottom: "15px" ,paddingLeft: "105px"}}>
                          <FormGroup>
                            <Autocomplete
                              id="include-input-in-list"
                              includeInputInList
                              className="ajouter-client-input"
                              // options={this.state.rechsc}
                              options={
                                this.state.clicked
                                  ? this.state.rechsc
                                  : this.props.clients.clients
                              }
                              getOptionLabel={(option) => option.codcli}
                              onChange={(event, getOptionLabel) => {
                                getOptionLabel
                                  ? this.setState({
                                      raisonsocial: getOptionLabel.raisoc,
                                      remiseg: getOptionLabel.remise,
                                      codeclient: getOptionLabel.codcli,
                                      categoriefiscale: getOptionLabel.catfisc,
                                      btnEnable: true,
                                      showFodec:getOptionLabel.fodec,
                                      showTimbre: getOptionLabel.timbre,
                                      showForfitaire: getOptionLabel.regimecli,
                                      showButtonModalPassager:
                                        getOptionLabel.passager,
                                      cemail: getOptionLabel.email,
                                    })
                                  : this.setState({
                                      raisonsocial: this.props.raisonsociale,
                                      remiseg: this.props.taurem,
                                      codeclient: this.props.client,
                                      categoriefiscale: this.props.catfisc,
                                      btnEnable: false,
                                      showTimbre: false,
                                      showFodec:false,
                                      showForfitaire: 0,
                                      showButtonModalPassager: false,
                                    });
                              }}
                              renderInput={(params) => (
                                <TextField
                                  // {...params}
                                  label={translate("Code client")}
                                  // className="card add-input"
                                  margin="dense"
                                  variant="outlined"
                                  fullWidth
                                  onChange={this.clientHandlerChange}
                                  name="codcli"

                                  InputProps={{
                                    ...params.InputProps,
                                    className: !darck
                                      ? this.props.classes.input
                                      : null,
                                  }}
                                  inputProps={params.inputProps}
                                  id={params.id}
                                  InputLabelProps={{
                                    style: {
                                      color: !darck ? "#fff" : null,
                                    },
                                  }}
                                />
                              )}
                            />
                          </FormGroup>
                        </Col>
                      ) : (
                        <Col sm={4} style={{  marginBottom: "15px" ,paddingLeft: "105px"}}>
                          <FormGroup>
                            <Autocomplete
                              id="include-input-in-list"
                              includeInputInList
                              className="ajouter-client-input"
                              // options={this.state.rechsc}
                              options={
                                this.state.clicked
                                  ? this.state.rechsc
                                  : this.props.clients.clients
                              }
                              getOptionLabel={(option) => option.raisoc}
                              onChange={(event, getOptionLabel) => {
                                getOptionLabel
                                  ? this.setState({
                                      raisonsocial: getOptionLabel.raisoc,
                                      remiseg: getOptionLabel.remise,
                                      codeclient: getOptionLabel.codcli,
                                      categoriefiscale: getOptionLabel.catfisc,
                                      btnEnable: true,
                                      showFodec:getOptionLabel.fodec,
                                      showTimbre: getOptionLabel.timbre,
                                      showForfitaire: getOptionLabel.regimecli,
                                      showButtonModalPassager:
                                        getOptionLabel.passager,
                                      cemail: getOptionLabel.email,
                                    })
                                  : this.setState({
                                      raisonsocial: this.props.raisonsociale,
                                      remiseg: this.props.taurem,
                                      codeclient: this.props.client,
                                      categoriefiscale: this.props.catfisc,
                                      btnEnable: false,
                                      showTimbre: false,
                                      showFodec:false,
                                      showForfitaire: 0,
                                      showButtonModalPassager: false,
                                    });
                              }} 
                              renderInput={(params) => (
                                <TextField
                                  // {...params}
                                  label={translate("Raison social")}
                                  // className="card add-input"
                                  margin="dense"
                                  variant="outlined"
                                  fullWidth
                                  onChange={this.clientHandlerChange}
                                  name="raissoc"
                                  InputProps={{
                                    ...params.InputProps,
                                    className: !darck
                                      ? this.props.classes.input
                                      : null,
                                  }}
                                  inputProps={params.inputProps}
                                  id={params.id}
                                  InputLabelProps={{
                                    style: {
                                      color: !darck ? "#fff" : null,
                                    },
                                  }}
                                />
                              )}
                            />
                          </FormGroup>
                        </Col>
                      )}
                    </Row>

                    <Row style={{ marginBottom: "-20px" }}>
                      <Col sm={2}>
                        <FormGroup>
                          <TextField
                            id="standard-basic"
                            label={translate("Code client")}
                            // className="card add-input"
                            margin="dense"
                            variant="outlined" //variant="outlined"
                            value={this.state.codeclient}
                            fullWidth
                            name="codcli"
                            disabled
                            InputProps={{
                              className: !darck
                                ? this.props.classes.input
                                : null,
                              style: {
                                color: !darck ? "#fff" : null,
                              },
                            }}
                            InputLabelProps={{
                              shrink: true,
                              style: {
                                color: !darck ? "#fff" : null,
                              },
                            }}
                          />
                        </FormGroup>
                      </Col>
                  

                      <Col sm={5}>
                        <FormGroup>
                          <TextField
                            id="standard-basic"
                            label={translate("Raison social")}
                            // className="card add-input"
                            margin="dense"
                            variant="outlined" 
                            //variant="outlined"
                            value={this.state.raisonsocial}
                            fullWidth
                            name="raissoc"
                            disabled={
                              this.state.codeclient === "100" ? false : true
                            }
                            onChange={this.raisocHandler}

                            InputProps={{
                              className: !darck
                                ? this.props.classes.input
                                : null,
                              style: {
                                color: !darck ? "#fff" : null,
                              },
                            }}
                            InputLabelProps={{
                              style: {
                                color: !darck ? "#fff" : null,
                              },
                            }}
                          />
                        </FormGroup>
                      </Col>

                      <Col sm={2}>
                        <TextField
                          id="standard-basic"
                          label={translate("Remise Globale %")}
                          // className="card add-input"
                          margin="dense"
                          variant="outlined" //variant="outlined"
                          fullWidth
                          name="remise"
                          onChange={this.remiseglobalChange}
                          value={this.state.remiseg}
                          InputProps={{
                            className: !darck ? this.props.classes.input : null,
                          }}
                          InputLabelProps={{
                            shrink: true,
                            style: {
                              color: !darck ? "#fff" : null,
                            },
                          }}
                        />
                      </Col>

                      <Col sm={3}>
                        <TextField
                          id="standard-basic"
                          label="Date"
                          // className="card add-input"
                          margin="dense"
                          variant="outlined"
                          type="date"
                          fullWidth
                          name="datfac"
                          onChange={this.datHandler}
                          value={this.state.datebcc}
                          InputProps={{
                            className: !darck ? this.props.classes.input : null,
                          }}
                          InputLabelProps={{
                            shrink: true,
                            style: {
                              color: !darck ? "#fff" : null,
                            },
                          }}
                          // defaultValue={new Date(this.props.datebl)
                          //   .toISOString()
                          //   .substr(0, 10)}
                        />
                      </Col>
                    
                    </Row>
                  </Card.Body>
                </Card>

                <Card>
                  <Card.Body
                    style={{
                      backgroundColor: `${darck ? "#fff" : "#172431"}`,
                      border: `${darck ? "" : "2px solid #fff"}`,
                    }}
                  >
                    <form
                      autocomplete="off"
                      onSubmit={this.submitHandler}
                      className={`${darck ? "" : classes.root}`}
                    >
  <Row form>
                        <b style={{ color: `${darck ? "" : "#fff"}` }}>Chercher article par :</b>
                        <b style={{ marginTop: "0px", marginLeft: "10px" }}>
                          {this.state.faudec === "V" ? (
                            <p style={{ color: "grey" }}>Fodec: ✔</p>
                           ) : null}
                        </b>
                      </Row>
                      <Row form>
                        <Col sm={3}>
                          <FormGroup>
                            <Autocomplete
                              id="include-input-in-list"
                              includeInputInList
                              className="ajouter-client-input"
                              //   options={this.props.articles.articles}
                              // options={this.state.rechs}
                              options={
                                this.state.clickeda
                                  ? this.state.rechs
                                  : this.props.articles.articles
                              }
                              getOptionLabel={(option) => option.codart}
                              onChange={(event, getOptionLabel) => {
                                getOptionLabel
                                  ? this.setState({
                                      codearticle: getOptionLabel.codart,
                                      des: getOptionLabel.desart,
                                      unite: getOptionLabel.unite,
                                      puht: getOptionLabel.PUDHT,
                                      remisea: getOptionLabel.remise,
                                      tva: getOptionLabel.tautva,
                                      faudec: getOptionLabel.typfodec,
                                      stkfin: getOptionLabel.stkfin,
                                    })
                                  : this.setState({
                                      codearticle: "",
                                      totalht: 0,
                                      des: "",
                                      unite: "",
                                      puht: "",
                                      remisea: 0,
                                      tva: 0,
                                      faudec: "",
                                      stkfin: 0,
                                    });
                              }}
                              renderInput={(params) => (
                                <TextField
                                  // {...params}
                                  label="Code article"
                                  // className="card add-input"
                                  margin="dense"
                                  variant="outlined"
                                  fullWidth
                                  onChange={this.articleHandlerChange}
                                  InputProps={{
                                    ...params.InputProps,
                                    className: !darck
                                      ? this.props.classes.input
                                      : null,
                                  }}
                                  inputProps={params.inputProps}
                                  id={params.id}
                                  InputLabelProps={{
                                    style: {
                                      color: !darck ? "#fff" : null,
                                    },
                                  }}
                                />
                              )}
                            />
                          </FormGroup>
                        </Col>
                     {/*  <Col sm={3}>
                          <FormGroup>
                            <Autocomplete
                              id="include-input-in-list"
                              includeInputInList
                              className="ajouter-client-input"
                              //   options={this.props.articles.articles}
                              // options={this.state.rechs}
                              options={
                                this.state.clicked
                                  ? this.state.rechs
                                  : this.props.articles.articles
                              }
                              getOptionLabel={(option) => option.codart}
                              onChange={(event, getOptionLabel) => {
                                getOptionLabel
                                  ? this.setState({
                                      codearticle: getOptionLabel.codart,
                                      des: getOptionLabel.desart,
                                      unitee: getOptionLabel.unite,
                                      puht: Number(
                                        getOptionLabel.PUDHT
                                      ).toFixed(3),
                                      remisea: getOptionLabel.remise,
                                      tva: getOptionLabel.tautva,
                                      faudec: getOptionLabel.typfodec,
                                      stkfin: getOptionLabel.stkfin,
                                      codtvaa: getOptionLabel.codtva,
                                      pmp: getOptionLabel.pmp,
                                      codbar: getOptionLabel.codbar,
                                    })
                                  : this.setState({
                                      codearticle: "",
                                      totalht: 0,
                                      des: "",
                                      unitee: "",
                                      puht: "",
                                      remisea: 0,
                                      tva: 0,
                                      faudec: "",
                                      stkfin: 0,
                                      codtvaa: "",
                                      codbar: "",
                                      pmp: "",
                                      qte: "",
                                    });
                              }}
                              renderInput={(params) => (
                                <TextField
                                  // {...params}
                                  label={translate("Code article")}
                                  // className="card add-input"
                                  margin="dense"
                                  variant="outlined"
                                  fullWidth
                                  onChange={this.articleHandlerChange}

                                  InputProps={{
                                    ...params.InputProps,
                                    className: !darck
                                      ? this.props.classes.input
                                      : null,
                                  }}
                                  inputProps={params.inputProps}
                                  id={params.id}
                                  InputLabelProps={{
                                    style: {
                                      color: !darck ? "#fff" : null,
                                    },
                                  }}
                                />
                              )}
                            />
                          </FormGroup>
                        </Col> */}
               
               <Col sm={6}>
                          <FormGroup>
                            <Autocomplete
                              id="include-input-in-list"
                              includeInputInList
                              className="ajouter-client-input"
                              //   options={this.props.articles.articles}
                              // options={this.state.rechs}
                              options={
                                this.state.clickeda
                                  ? this.state.rechs
                                  : this.props.articles.articles
                              }
                              getOptionLabel={(option) => option.desart}
                              onChange={(event, getOptionLabel) => {
                                getOptionLabel
                                  ? this.setState({
                                      codearticle: getOptionLabel.codart,
                                      des: getOptionLabel.desart,
                                      unite: getOptionLabel.unite,
                                      puht: getOptionLabel.PUDHT,
                                      remisea: getOptionLabel.remise,
                                      tva: getOptionLabel.tautva,
                                      faudec: getOptionLabel.typfodec,
                                      stkfin: getOptionLabel.stkfin,
                                    })
                                  : this.setState({
                                      codearticle: "",
                                      totalht: 0,
                                      des: "",
                                      unite: "",
                                      puht: "",
                                      remisea: 0,
                                      tva: 0,
                                      faudec: "",
                                      stkfin: 0,
                                    });
                              }}
                              renderInput={(params) => (
                                <TextField
                                  // {...params}
                                  label="Désignation article"
                                  // className="card add-input"
                                  margin="dense"
                                  variant="outlined"
                                  fullWidth
                                  onChange={this.articleHandlerChange}
                                  InputProps={{
                                    ...params.InputProps,
                                    className: !darck
                                      ? this.props.classes.input
                                      : null,
                                  }}
                                  inputProps={params.inputProps}
                                  id={params.id}
                                  InputLabelProps={{
                                    style: {
                                      color: !darck ? "#fff" : null,
                                    },
                                  }}
                                />
                              )}
                            />
                          </FormGroup>
                        </Col>

                        <Col sm={3}>
                          <FormGroup>
                            <Autocomplete
                              id="include-input-in-list"
                              includeInputInList
                              className="ajouter-client-input"
                              //   options={this.props.articles.articles}
                              // options={this.state.rechs}
                              options={
                                this.state.clicked
                                  ? this.state.rechs
                                  : this.props.articles.articles
                              }
                              getOptionLabel={(option) => option.codbar}
                              onChange={(event, getOptionLabel) => {
                                getOptionLabel
                                  ? this.setState({
                                      codearticle: getOptionLabel.codart,
                                      des: getOptionLabel.desart,
                                      unitee: getOptionLabel.unite,
                                      puht: Number(
                                        getOptionLabel.PUDHT
                                      ).toFixed(3),
                                      remisea: getOptionLabel.remise,
                                      tva: getOptionLabel.tautva,
                                      faudec: getOptionLabel.typfodec,
                                      stkfin: getOptionLabel.stkfin,
                                      codtvaa: getOptionLabel.codtva,
                                      pmp: getOptionLabel.pmp,
                                      codbar: getOptionLabel.codbar,
                                    })
                                  : this.setState({
                                      codearticle: "",
                                      totalht: 0,
                                      des: "",
                                      unitee: "",
                                      puht: "",
                                      remisea: 0,
                                      tva: 0,
                                      faudec: "",
                                      stkfin: 0,
                                      qte: "",
                                      codbar: "",
                                      codtvaa: "",
                                      puttcnet: 0,
                                      pmp: "",
                                    });
                              }}
                              renderInput={(params) => (
                                <TextField
                                  // {...params}
                                  label={translate("Code à Barre")}
                                  // className="card add-input"
                                  margin="dense"
                                  variant="outlined"
                                  fullWidth
                                  onChange={this.articleHandlerChange}

                                  InputProps={{
                                    ...params.InputProps,
                                    className: !darck
                                      ? this.props.classes.input
                                      : null,
                                  }}
                                  inputProps={params.inputProps}
                                  id={params.id}
                                  InputLabelProps={{
                                    style: {
                                      color: !darck ? "#fff" : null,
                                    },
                                  }}
                                />
                              )}
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row form>
                        <Col sm={3}>
                          <FormGroup>
                            <TextField
                              id="standard-basic"
                              label={translate("Code article")}
                              value={this.state.codearticle}
                              disabled
                              // className="card add-input"
                              margin="dense"
                              variant="outlined"
                              fullWidth
                              InputProps={{
                                className: !darck
                                  ? this.props.classes.input
                                  : null,
                                style: {
                                  color: !darck ? "#fff" : null,
                                },
                              }}
                              InputLabelProps={{
                                style: {
                                  color: !darck ? "#fff" : null,
                                },
                              }}
                            />
                          </FormGroup>
                        </Col>
                        <Col sm={6}>
                          <FormGroup>
                            <TextField
                              id="standard-basic"
                              label={translate("Désignation")}
                              value={this.state.des}
                              disabled
                              // className="card add-input"
                              margin="dense"
                              variant="outlined"
                              fullWidth

                              InputProps={{
                                className: !darck
                                  ? this.props.classes.input
                                  : null,
                                style: {
                                  color: !darck ? "#fff" : null,
                                },
                              }}
                              InputLabelProps={{
                                style: {
                                  color: !darck ? "#fff" : null,
                                },
                              }}
                            />
                          </FormGroup>
                        </Col>

                        <Col sm={1}>
                          <FormGroup>
                            {/* {this.state.des === "" ? (
                              <TextField
                                id="standard-basic"
                                label={translate("Quantité")}
                                type="number"
                                disabled
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                style={{ marginTop: "16px" }}
                                margin="normal"
                                fullWidth
                                required
                              />
                            ) : ( */}
                            <TextField
                              id="standard-basic"
                              label="Qte"
                              type="number"
                              value={this.state.qte}
                              onChange={this.qteHandler}
                              // className="card add-input"
                              margin="dense"
                              variant="outlined"
                              fullWidth
                              required
                              
                              InputProps={{
                                className: !darck
                                  ? this.props.classes.input
                                  : null,
                                style: {
                                  color: !darck ? "#fff" : null,
                                },
                              }}
                              InputLabelProps={{
                                shrink: true,
                                style: {
                                  color: !darck ? "#fff" : null,
                                  textAlign: "center",
                                },
                              }}
                            />
                            {/* )} */}

                            {/* {this.state.qte > this.state.stkfin && (
                              <FormHelperText style={{ color: "#DC004E" }}>
                                {translate("Stock insuffisant!")}
                              </FormHelperText>
                            )} */}
                          </FormGroup>
                        </Col>
                        <Col sm={2}>
                          <FormGroup>
                            <TextField
                              value={`Stock: ${this.state.stkfin}`}
                              // className="card add-input"
                              margin="dense"
                              variant="outlined"
                              disabled
                              InputProps={{
                                className: !darck
                                  ? this.props.classes.input
                                  : null,
                                style: {
                                  color: !darck ? "#fff" : null,
                                },
                              }}
                              InputLabelProps={{
                                style: {
                                  color: !darck ? "#fff" : null,
                                },
                              }}
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row form>
                        <Col sm={2}>
                          <FormGroup>
                            <TextField
                              id="standard-basic"
                              label={translate("Unité")}
                              value={this.state.unite}
                              fullWidth
                              disabled
                              size="small"
                              // className="card add-input"
                              margin="dense"
                              variant="outlined"
                              InputProps={{
                                className: !darck
                                  ? this.props.classes.input
                                  : null,
                                style: {
                                  color: !darck ? "#fff" : null,
                                },
                              }}
                              InputLabelProps={{
                                style: {
                                  color: !darck ? "#fff" : null,
                                },
                              }}
                            />
                          </FormGroup>
                        </Col>

                        <Col sm={2}>
                          <FormGroup>
                            <TextField
                              id="standard-basic"
                              label={translate("PUHT")}
                              value={this.state.puht}
                              fullWidth
                              name="puht"
                              onChange={this.puhtHandler}
                              // className="card add-input"
                              margin="dense"
                              variant="outlined"
                              InputProps={{
                                className: !darck
                                  ? this.props.classes.input
                                  : null,
                                style: {
                                  color: !darck ? "#fff" : null,
                                },
                              }}
                              InputLabelProps={{
                                style: {
                                  color: !darck ? "#fff" : null,
                                },
                              }}
                            />
                          </FormGroup>
                        </Col>

                        <Col sm={2}>
                          <FormGroup>
                            <TextField
                              id="standard-basic"
                              label={translate("Remise %")}
                              value={this.state.remisea}
                              fullWidth
                              name="remisea"
                              // className="card add-input"
                              margin="dense"
                              variant="outlined"
                              onChange={this.remiseHandler}
                              InputProps={{
                                className: !darck
                                  ? this.props.classes.input
                                  : null,
                                style: {
                                  color: !darck ? "#fff" : null,
                                },
                              }}
                              InputLabelProps={{
                                style: {
                                  color: !darck ? "#fff" : null,
                                },
                              }}
                            />
                          </FormGroup>
                        </Col>

                        <Col sm={2}>
                          <FormGroup>
                            <TextField
                              id="standard-basic"
                              label={translate("TVA")}
                              value={this.state.tva}
                              fullWidth
                              disabled
                              // className="card add-input"
                              margin="dense"
                              variant="outlined"
                              InputProps={{
                                className: !darck
                                  ? this.props.classes.input
                                  : null,
                                style: {
                                  color: !darck ? "#fff" : null,
                                },
                              }}
                              InputLabelProps={{
                                style: {
                                  color: !darck ? "#fff" : null,
                                },
                              }}
                            />
                          </FormGroup>
                        </Col>
                        <Col sm={2}>
                          <FormGroup>
                            <TextField
                              id="standard-basic"
                              label={translate("PUTTCNet")}
                              value={this.state.puttcnet}
                              fullWidth
                              onChange={this.puttcHandler}
                              // className="card add-input"
                              margin="dense"
                              variant="outlined"
                              InputProps={{
                                className: !darck
                                  ? this.props.classes.input
                                  : null,
                                style: {
                                  color: !darck ? "#fff" : null,
                                },
                              }}
                              InputLabelProps={{
                                style: {
                                  color: !darck ? "#fff" : null,
                                },
                              }}
                            />
                          </FormGroup>
                        </Col>

                        <Col sm={2}>
                          <FormGroup>
                            <TextField
                              id="standard-basic"
                              label={translate("TotalHT")}
                              value={Number(this.state.totalht).toFixed(3)}
                              fullWidth
                              disabled
                              // className="card add-input"
                              margin="dense"
                              variant="outlined"
                              InputProps={{
                                className: !darck
                                  ? this.props.classes.input
                                  : null,
                                style: {
                                  color: !darck ? "#fff" : null,
                                },
                              }}
                              InputLabelProps={{
                                style: {
                                  color: !darck ? "#fff" : null,
                                },
                              }}
                            />
                          </FormGroup>
                        </Col>
                      </Row>

                      {this.state.changeButton ? (
                        <Center>
                          <Button
                           // disabled={
                            //  this.state.yesno === "no" ||
                            //  this.state.qte === "" ||
                            //  this.state.stkfin <= 0 ||
                             // parseInt(this.state.qte) <= 0
                              //  ? true
                              //  : false
                           // }
                            style={{ width: "320px" }}
                            variant="contained"
                            color="primary"
                            onClick={() => {
                              this.modifiermodification();
                            }}
                          >
                            {translate("Enregistrer les modifications")}
                          </Button>
                        </Center>
              //  ) : this.state.des === "" ||
             //  this.state.yesno === "no" ||
             //  this.state.qte === "" ||
            //   this.state.stkfin <= 0 ||
            //   parseInt(this.state.qte) <= 0 ? (


                          ) : this.state.des === "" ? (
                        <Center>
                          <Button
                            disabled
                            style={{ width: "250px" }}
                            variant="contained"
                            color="primary"
                            type="submit"
                          >
                            {translate("Ajouter")}
                          </Button>
                        </Center>
                      ) : (
                        <Center>
                          <Button
                            style={{ width: "250px" }}
                            variant="contained"
                            color="primary"
                            type="submit"
                          >
                            {translate("Ajouter")}
                          </Button>
                        </Center>
                      )}
                    </form>
                  </Card.Body>
                </Card>

                <Card style={{ marginTop: "10px" }}>
                  <Card.Body
                    style={{
                      backgroundColor: `${darck ? "#fff" : "#172431"}`,
                      border: `${darck ? "" : "2px solid #fff"}`,
                    }}
                  >
                    <div className="tabbl2">
                      <table
                        className={`${darck ? "" : classes.root}`}
                        style={{
                          marginTop: "10px",
                          backgroundColor: `${darck ? "#fff" : "#172431"}`,
                        }}
                      >
                        <thead
                          style={{ textAlign: "center", fontSize: "12px" }}
                        >
                          <tr>
                            <th>Code</th>
                            <th style={{ width: "37%" }}>
                              {" "}
                              {translate("Désignation")}{" "}
                            </th>
                            <th> {translate("Quantité")} </th>
                            {Number(this.props.InfoEntreprise?.[0]?.taufodec ?? 0) !== 0 &&(<th> {translate("Fodec")} </th>)}
                            <th> {translate("PUHT")} </th>
                            <th> {translate("Remise")} </th>
                            <th> {translate("TVA")} </th>
                            <th> {translate("TotalHT")} </th>
                            <th> {translate("PUNet")} </th>
                            <th></th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody
                          style={{
                            overflowY: "auto",
                            display: "block",
                            maxHeight: "10em",
                          }}
                        >
                          {this.state.tab.map((t, i) => (
                            <tr key={i}>
                              <td style={{ color: `${darck ? "" : "#fff"}` }}>
                                <span>{t.codart}</span>
                              </td>
                              <td
                                style={{
                                  fontSize: "12px",
                                  width: "37%",
                                  color: `${darck ? "" : "#fff"}`,
                                }}
                              >
                                {t.desart}
                              </td>
                              <td style={{ color: `${darck ? "" : "#fff"}` }}>
                                <span>{t.quantite}</span>
                              </td>
                              {/* {Number(this.props.InfoEntreprise?.[0]?.taufodec ?? 0) !== 0 &&
                          ( <td>console.log("fodart faudec",this.state.faudec)
                          <span>
                            {t.fodart === "V" ||
                            t.fodart === "v" ||
                            t.fodart === 1 ||
                            t.fodart === true
                              ? "✔"
                              : "✖"}
                          </span>
                        </td>)} */}
                              {Number(this.props.InfoEntreprise?.[0]?.taufodec ?? 0) !== 0 && (
                              <td>
                              
                                <span>
                                  {t.faudec === "V" ||
                                  t.faudec === "v" ||
                                  t.faudec === 1 ||
                                  t.faudec === true
                                    ? "✔"
                                    : "✖"}
                                </span>
                              </td>
                            )}

                              <td style={{ color: `${darck ? "" : "#fff"}` }}>
                                <span>{Number(t.priuni).toFixed(3)}</span>
                              </td>

                              <td style={{ color: `${darck ? "" : "#fff"}` }}>
                                <span>{Number(t.remise).toFixed(2)}</span>
                              </td>
                              <td style={{ color: `${darck ? "" : "#fff"}` }}>
                                <span>{Number(t.tautva).toFixed(2)}</span>
                              </td>
                              <td style={{ color: `${darck ? "" : "#fff"}` }}>
                                <span>{Number(t.montht).toFixed(3)}</span>
                              </td>
                              <td style={{ color: `${darck ? "" : "#fff"}` }}>
                                <span>{Number(t.PUTTCNET).toFixed(3)}</span>
                              </td>
                              <td style={{ color: `${darck ? "" : "#fff"}` }}>
                                <Tooltip
                                  title={translate("Modifier cet article")}
                                >
                                  <Fab size="small">
                                    <EditIcon
                                      style={{}}
                                      onClick={() => {
                                        fetch(
                                          `https://www.24-crm.tn/webservice/api/ARTICLEs?codartt=${t.codart}&coddos=${this.props.ConfigDossier.coddos}&serveur=${this.props.ConfigDossier.serveur}&user=${this.props.ConfigDossier.utilisateur}&pwd=${this.props.ConfigDossier.pwd_serveur}&database=${this.props.ConfigDossier.database}`
                                        )
                                          .then((response) => response.json())
                                          .then((data) => {
                                            this.setState({
                                              stkfin: data.map((t) => t.stkfin),
                                            });
                                          });
                                         
                                        this.setState({
                                          codearticle: t.codart,
                                          des: t.desart,
                                          unite: t.unite,
                                          puht: t.priuni,
                                          remisea: t.remise,
                                          tva: t.tautva,
                                          faudec: t.fodart,
                                          qte: t.quantite,
                                          totalht: t.montht,
                                          puttcnet: t.PUTTCNET,
                                          pmp: t.pmp,
                                          changeButton: true,
                                        });
                                        this.deleteRowMod(i);
                                      }}
                                    />
                                  </Fab>
                                </Tooltip>
                              </td>
                              <td style={{ color: `${darck ? "" : "#fff"}` }}>
                                <Tooltip
                                  title={translate("Supprimer cet article")}
                                >
                                  <Fab size="small">
                                    <DeleteIcon
                                      style={{}}
                                      onClick={() => this.deleteRow(i)}
                                    />
                                  </Fab>
                                </Tooltip>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
            <EditRowModal
              show={this.state.openEditModal}
              onHide={EditModalClose}
              quantt={quantt}
              remiss={remiss}
              artid={artid}
              totalhtt={totalhtt}
              puttcnett={puttcnett}
              numfacccc={numfacccc}
             
              numligg={numligg}
              prixunix={prixunix}
              tab={this.state.tab}
            />
          </Modal.Body>
          <Modal.Footer
            style={{
              backgroundColor: `${darck ? "" : "#172431"}`,
              borderTop: `none`,
              borderRight: `${darck ? "" : "2px solid #fff"}`,
              borderLeft: `${darck ? "" : "2px solid #fff"}`,
              border: `${darck ? "" : "2px solid #fff"}`,
            }}
          >
            {!this.state.btnEnabled ? (
              <Button disabled variant="contained" style={{ width: "30%" }}>
                {translate("Enregistrer")}
              </Button>
            ) : (
              <Button
                variant="contained"
                style={{
                  backgroundColor: "rgb(0, 8, 126)",
                  color: "white",
                  width: "30%",
                }}
                onClick={() => {
                  // this.props.submitHandler(this.state.tab,
                  //     this.state.totalqte,
                  //     this.state.sumremisearticle,
                  //     this.state.totalhtbrut,
                  //     this.state.totaltva,
                  //     this.state.totalhtnet,
                  //     this.state.remiseglobal,
                  //     this.state.netapayer,
                  //     this.state.btnEnabled,
                  // )
                  this.enregistrer();
                  this.props.onHide();
                  this.props.onHide01();
                  window.alert("Modification enregistrés");
                 
                  this.props.SelectBL(
                    this.props.ConfigDossier.coddos,
                    this.props.ConfigDossier.serveur,
                    this.props.ConfigDossier.utilisateur,
                    this.props.ConfigDossier.pwd_serveur,
                    this.props.ConfigDossier.database
                  );
                }}
              >
                {translate("Enregistrer")} 
              </Button>
            )}
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    SelectArticle: (a, b, c, d, e) => dispatch(SelectArticle(a, b, c, d, e)),
    SelectBL: (a, b, c, d, e) => dispatch(SelectBL(a, b, c, d, e)),
    SelectClient: (a, b, c, d, e) => dispatch(SelectClient(a, b, c, d, e)),
  };
}

function mapStateToProps(state) {
  return {
    articles: state.articles,
    clients: state.clients,
    Auth: state.Auth,
    ConfigDossier: state.ConfigDossier,
    darck: state.darck.darck,
    InfoEntreprise: state.InfoDossier,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(stylesFn)(ModifierBLModal));
